import { route } from 'react-router-typesafe-routes';

export const PLAN_CONDITIONS_ROUTE = route({ path: 'plan/:planId/conditions' });
